import React from 'react';
import { Button, Card, Modal, message as antdMessage } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { getMessageDetailsThemeColors } from '../MessageDetails.helpers';

const MessageDeleteAction = ({
    messageId,
    onDeleteMessage,
    onClose,
    isDarkMode,
    deleteLoading,
    setDeleteLoading,
}) => {
    const { t } = useTranslation();
    const themeColors = getMessageDetailsThemeColors(isDarkMode);

    if (!onDeleteMessage) return null;

    const handleDeleteMessage = () => {
        Modal.confirm({
            title: t('delete_message'),
            content: t('delete_message_confirmation'),
            icon: <ExclamationCircleOutlined />,
            okText: t('delete'),
            cancelText: t('cancel'),
            okType: 'danger',
            centered: true,
            onOk: async () => {
                setDeleteLoading(true);
                try {
                    await onDeleteMessage(messageId);
                    antdMessage.success(t('message_deleted_successfully'));
                    if (onClose) {
                        onClose();
                    }
                } catch (error) {
                    antdMessage.error(error.response?.data?.message || t('error_deleting_message'));
                } finally {
                    setDeleteLoading(false);
                }
            }
        });
    };

    return (
        <Card title={t('actions')} style={{ background: themeColors.cardBackground }}>
            <Button
                type="default"
                danger
                icon={<DeleteOutlined />}
                loading={deleteLoading}
                onClick={handleDeleteMessage}
                block
            >
                {t('delete_message')}
            </Button>
        </Card>
    );
};

export default MessageDeleteAction;
